import { render, staticRenderFns } from "./DashboardGraphs.vue?vue&type=template&id=4bfd309c&scoped=true&lang=pug"
import script from "./DashboardGraphs.vue?vue&type=script&lang=ts"
export * from "./DashboardGraphs.vue?vue&type=script&lang=ts"
import style0 from "./DashboardGraphs.vue?vue&type=style&index=0&id=4bfd309c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfd309c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCard,VCardText,VSelect})
